import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import HiddenDiv from 'components/core/HiddenDiv.component';
import PUSHER from 'config/pusher.singleton';
import ELID from 'constants/elid.const';
import logger from 'utils/logger.util';
import { isNotValidId } from 'utils/predicates/fields.util';

import { PUSH_PIN_SETTINGS_CHANGE } from 'lib/constants/libConstants';

const L = logger('PinSettingsWatcher');

const PinSettingsWatcher = () => {
  const params = useParams();
  const salonId = params.salonId ?? params.id ?? null;

  useEffect(() => {
    if (isNotValidId(salonId)) {
      L.debug('useEffect()', 'Not valid salonId:', salonId);
      return;
    }

    const channelName = `${salonId}_channel`;
    const eventName = 'salon_settings';
    const actionType = PUSH_PIN_SETTINGS_CHANGE;

    PUSHER.redux.subscribe({ channelName, eventName, actionType });

    return () => void PUSHER.redux.unsubscribe({ channelName, eventName, actionType });
  }, [salonId]);

  return <HiddenDiv tag="PinSettingsWatcher--hidden" id={ELID.pinwatch} />;
};

export default PinSettingsWatcher;
